// extracted by mini-css-extract-plugin
export default {"maincontainer":"editcard_maincontainer__HMtbE","icontitle":"editcard_icontitle__ZbtIP","detailss":"editcard_detailss__jmq4P"};